import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import './Navbar.scss';
import UserPool from '../../UserPool';
import { RESET_STATE } from '../../actions/actionTypes';
import { fetchProfile } from '../../actions/advisorProfileActions';
import Avatar from '@mui/material/Avatar';
import SkeletonComponent from '../Skeleton/Skeleton';

function Navbar({ variant = 'main' }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const modalRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const advisorProfile = useSelector((state) => state.advisorProfile.profileData);
    const profileImage = useSelector((state) => state.userPicture.userPictureData?.profile_picture) || null;
    const subscriptionsDetails = useSelector((state) => state.userSubscription.subscriptionData) || {};
    const { user_type: userType, customer_id: CustomerID } = subscriptionsDetails;
    const nameInitial = advisorProfile?.firstname?.charAt(0)?.toUpperCase() || '';
    const familyNameInitial = advisorProfile?.lastname?.charAt(0)?.toUpperCase() || '';
    const userInitials = nameInitial + familyNameInitial;
    const fullName = advisorProfile?.firstname && advisorProfile?.lastname ? `${advisorProfile.firstname} ${advisorProfile.lastname}`: '';
    const isLoading = !advisorProfile?.firstname || !advisorProfile?.lastname;

    const navigate = (path) => {
        history.push(path);
    };

    const logout = () => {
        const user = UserPool.getCurrentUser();
        if (user) {
            user.signOut();
        }
        window.sessionStorage.clear();
        window.localStorage.clear();
        document.cookie.split(";").forEach((c) => {
            document.cookie = c
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        dispatch({ type: RESET_STATE });
        history.push('/');
    };

    useEffect(() => {
        if (variant === 'profile' && Object.keys(advisorProfile).length === 0) {
            dispatch(fetchProfile());
        }
    }, [variant, dispatch, advisorProfile]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowModal(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const UserModal = () => (
        <div className="user-modal" ref={modalRef}>
            <div className="modal-item" onClick={() => navigate('/AdvisorProfileScreen')}>
                <img src="Assets/profile.svg" alt="Profile" className="modal-icon" />
                Profile
            </div>
            <div className="modal-item" onClick={() => navigate('/ClientPortfolios')}>
                <img src="Assets/portfoio.svg" alt="Portfolios" className="modal-icon" />
                Portfolios
            </div>
            {subscriptionsDetails.advisor_admin &&
                subscriptionsDetails.subscription_plan_type === 'Adaptive Advisor Firm Plan' && (
                <div className="modal-item" onClick={() => navigate('/ManageUsers')}>
                    <img src="Assets/portfoio.svg" alt="Manage Users" className="modal-icon" />
                    Manage Users
                </div>
                )}
            <div className="modal-item" onClick={logout}>
                <img src="Assets/signout.svg" alt="Logout" className="modal-icon" />
                Logout
            </div>
        </div>
    );

    return (
        <div className="navbar">
            <img className="logo" alt="Logo" src="Assets/adaptive_logo.png" />
            {variant === 'profile' && (
                <ul className="navbar-center">
                    <li>
                        <a href="/ClientPortfolios">Back to Dashboard</a>
                    </li>
                </ul>
            )}
            {isLoading ? (
                <SkeletonComponent variant={'navbar'} />
                ) : (
                <div className="navbar-right">
                    <a className="user-info" onClick={() => setShowModal(!showModal)}>
                        <span className="user-avatar">
                            {profileImage ? (
                            <Avatar
                                alt="User Avatar"
                                src={profileImage}
                                sx={{ width: 40, height: 40 }}
                            />
                            ) : (
                            userInitials
                            )}
                        </span>
                        {showModal && <UserModal />}
                        <div className="user-detail">
                            <span className="user-name">{fullName}</span>
                            <span className="user-role">{userType}</span>
                        </div>
                    </a>
                </div>
            )}
        </div>
    );
}

export default Navbar;
